import { get } from "../../utils/net";

import type { AnnouncementsResponse } from "./models";

export const getAnnouncements = async (): Promise<AnnouncementsResponse[]> => {
  const response = await get(`${process.env.REACT_APP_API_PATH}/api/Announcements`, {
    useExactPath: true,
  });

  return response.body;
};
